import Vue from 'vue'
import Vuex from 'vuex'
import uploadFiles from './uploadFiles'
import search from './search'
import publicStore from './public'
import basket from './basket'
import rpc from '../rpc'
import router from '../router'

Vue.use(Vuex)

function initialState() {
  return {
    logged_in: false,
    token: null,
    user: {name: ""},
    route: {name: ""},
    galleries: [],
    friendGalleries: [],
    galleriesById: {},
    bigImage: null,
    friends: [],
    friendsById: {},
    show_burger_menu: false
  };
}

export default new Vuex.Store({
  state: initialState,
  mutations: {
    reset(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    login(state, response) {
      state.logged_in = true;
      state.user = response.user;
      state.token = response.token;
    },
    logout(state) {
      state.logged_in = false;
      state.token = null;
    },
    routeChanged(state, newRoute) {
      state.route = newRoute;
    },
    gotGalleries(state, galleries) {
      state.galleries = galleries
      state.galleriesById = {}
      for(var g of galleries) {
        g.startDate = new Date(g.startTime);
        g.endDate = new Date(g.endTime);
        state.galleriesById[g.id] = g
      }
    },
    gotFriendGalleries(state, galleries) {
      state.friendGalleries = galleries
      for(var g of galleries) {
        g.startDate = new Date(g.startTime);
        g.endDate = new Date(g.endTime);
        state.galleriesById[g.id] = g
      }
    },
    gotGallery(state, gallery) {
      gallery.startDate = new Date(gallery.startTime);
      gallery.endDate = new Date(gallery.endTime);
      Vue.set(state.galleriesById, gallery.id, gallery);
    },
    hideBigImage(state) {
      state.bigImage = null;
    },
    showBigImage(state, imageId) {
      state.bigImage = imageId
    },
    galleryNameChanged(state, {galleryId, newName}) {
      state.galleriesById[galleryId].name = newName;
    },
    galleryPublicChanged(state, {galleryId, isPublic}) {
      state.galleriesById[galleryId].public = isPublic;
    },
    galleryPublicPWChanged(state, {galleryId, publicPW}) {
      state.galleriesById[galleryId].publicPW = publicPW;
    },
    galleryPasswordChanged(state, {galleryId, password}) {
      state.galleriesById[galleryId].password = password;
    },
    newRequestedFriend(state, friendRequest) {
      state.user.requestedFriends.push(friendRequest)
    },
    gotFriends(state, friends) {
      console.log(friends)
      Vue.set(state, "friends", friends)
      for(let friend of friends) {
        Vue.set(state.friendsById, friend.userFriendship.friendId, friend);
      }
    },
    newFriend(state, newFriend) {
      state.friends.push(newFriend);
    },
    friendshipUpdated(state, friendship) {
      console.log(friendship)
    }, 
    deleteFriendship(state, friendship) {
      Vue.delete(state.friendsById, friendship.userFriendship.friendId);
      let idx = state.friends.findIndex(friend => friend.userFriendship.id == friendship.userFriendship.id);
      Vue.delete(state.friends, idx);
      state.friendGalleries = state.friendGalleries.filter(gallery => gallery.userID != friendship.userFriendship.friendId);
      state.galleriesById = Object.keys(state.galleriesById)
          .filter( key => state.galleriesById[key].userID != friendship.userFriendship.friendId )
          .reduce( (res, key) => (res[key] = state.galleriesById[key], res), {} );
    },
    deleteFriendRequest(state, request) {
      console.log("new requests:", state.user.friendRequests);
      let filteredRequests = state.user.friendRequests.filter(req => req.ID != request.ID);
      console.log("filtered requests:", filteredRequests)
      Vue.set(state.user, "friendRequests", filteredRequests); 
    },
    deleteGallery(state, galleryId) {
      Vue.delete(state.galleriesById, galleryId);
      for(let i=0; i<state.galleries.length; i++) {
        if(state.galleries[i].id == galleryId) {
          Vue.delete(state.galleries, i);
          break;
        }
      }
    },
    showBurgerMenu(state) {
      state.show_burger_menu = true;
    },
    hideBurgerMenu(state) {
      state.show_burger_menu = false;
    }
  },
  actions: {
    deleteGallery({commit, state}, {galleryId, deleteImages}) {
      rpc.request("ImageService.DeleteGallery", {galleryId: parseInt(galleryId), deleteImages: deleteImages}).then(resp => {
        commit("deleteGallery", galleryId);
        router.push("/");
      }).catch(err => {
        //TODO: rollback friendship in the store
        console.log(err);
      })
    },
    windowKeyup({dispatch, state}, e) {
      switch(e.key) {
        case "ArrowRight":
          if(state.bigImage) {
            dispatch("nextBigImage");
          }
          break;
        case "ArrowLeft":
          if(state.bigImage) {
            dispatch("previousBigImage");
          }
          break;
          case "Escape":
            if(state.bigImage) {
              dispatch("hideBigImage");
            }
            break;
        default:
          break;
      }
    },
    async nextBigImage({commit, state}) {
      let showNextBigImageInGallery = async (gallery) => {
        let idx = gallery.imageIds.indexOf(state.bigImage.id);
        let newIdx = Math.min(gallery.imageIds.length-1, idx+1);
        if(newIdx == idx) {
          return;
        }
        let imageId = gallery.imageIds[newIdx];
        commit("showBigImage", {id: -1});
        let image = await rpc.request("ImageService.ImageByID", imageId)
        commit("showBigImage", image);
      };
      switch(state.route.name) {
        case "gallery":
          let id = parseInt(state.route.params.id);
          let gallery = state.galleriesById[id];
          showNextBigImageInGallery(gallery);
          break;
        case "Search":
          idx = state.search.searchResult.findIndex(im => im.id == state.bigImage.id);
          newIdx = Math.min(state.search.searchResult.length-1, idx+1);
          image = state.search.searchResult[newIdx];
          commit("showBigImage", {id: -1});
          commit("showBigImage", image);
          break;
        case "publicGallery":
          id = parseInt(state.route.params.id);
          gallery = state.public.galleriesById[id];
          showNextBigImageInGallery(gallery);
          break;
        default:
          break;
      }
    },
    async previousBigImage({commit, state}) {
      switch(state.route.name) {
        case "gallery":
          let id = parseInt(state.route.params.id);
          let gallery = state.galleriesById[id];
          let idx = gallery.imageIds.indexOf(state.bigImage.id);
          let newIdx = Math.max(0, idx-1);
          if(newIdx == idx) {
            return;
          }
          let imageId = gallery.imageIds[newIdx];
          commit("showBigImage", {id: -1});
          let image = await rpc.request("ImageService.ImageByID", imageId)
          commit("showBigImage", image);
          break;
        case "Search":
          idx = state.search.searchResult.findIndex(im => im.id == state.bigImage.id);
          newIdx = Math.max(0, idx+-1);
          image = state.search.searchResult[newIdx];
          commit("showBigImage", {id: -1});
          commit("showBigImage", image);
        default:
          break;
      }
    },
    getFriendGalleries({commit}, friendId) {
      rpc.request("ImageService.GetGalleries", friendId).then(resp => {
        commit("gotFriendGalleries", resp);
      }).catch(err => {
        //TODO: rollback friendship in the store
        console.log(err);
      })
    },
    toggleShareAll({commit}, friendship) {
      rpc.request("LoginService.UpdateFriendship", friendship).then(resp => {
        commit("friendshipUpdated", resp);
      }).catch(err => {
        friendship.shareAll = !friendship.shareAll
      })
    },
    confirmFriendship({commit}, request) {
      rpc.request("LoginService.ConfirmFriendship", request).then(resp => {
        commit("deleteFriendRequest", request)
        commit("newFriend", resp)
      }).catch(err => {
        console.log(err)
      })
    },
    unfriend({commit}, friendship) {
      rpc.request("LoginService.DeleteFriendship", friendship).then(resp => {
        commit("deleteFriendship", friendship);
      }).catch(err => {
        console.log(err)
      })
    },
    getFriends({commit}) {
      rpc.request("LoginService.GetFriends", {}).then(resp => {
        commit("gotFriends", resp);
      }).catch(err => {
        console.log(err);
      })
    },
    sendFriendRequest({commit, state}, username) {
      let request = {
        requestingUserId: state.user.id,
        requestinguserName: state.user.name,
        requestedUserName: username
      };
      rpc.request("LoginService.SendFriendRequest", request).then(resp => {
        console.log(resp)
        commit("newRequestedFriend", resp)
      }).catch(err => {
        console.log(err);
      })
    },
    updateGallery({commit, state}, galleryId) {
      rpc.request("ImageService.UpdateGallery", state.galleriesById[galleryId]).then( resp => {
        //TODO: commit something to the store to make clear everything worked out fine
      }).catch(err => {
        console.log(err);
      })
    },
    clearAll({commit}) {
      commit("reset");
      commit("uploadFiles/reset");
      commit("search/reset");
      commit("basket/reset");
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    },
    logout({commit, dispatch}) {
      dispatch("clearAll");
      commit("logout");
    },
    async getGalleries({commit, state}) {
      if(state.logged_in) {
        let answer = await rpc.request("ImageService.GetDashboardGalleries", state.user.id);
        commit("gotGalleries", answer);
      }
    },
    async getGallery({commit, state}, galleryId) {
      if(state.logged_in) {
        let answer = await rpc.request("ImageService.GetGallery", galleryId);
        commit("gotGallery", answer);
      }
    },
    routeChanged({dispatch, commit}, to) {
      if(to.name == "Friends") {
        dispatch("getFriends")
      }
      commit("routeChanged", to);
      commit("hideBigImage");
      commit("hideBurgerMenu")
    },
    showBigImage({commit}, imageId) {
      commit("showBigImage", imageId)
    },
    hideBigImage({commit}) {
      commit("hideBigImage")
    },
    toggleBurgerMenu({state, commit}) {
      if(state.show_burger_menu) {
        commit("hideBurgerMenu");
      } else {
        commit("showBurgerMenu")
      }
    }
  },
  modules: {
    public: publicStore,
    uploadFiles: uploadFiles,
    search: search,
    basket: basket
  }
})
